import { Injectable } from '@angular/core';

import { RestService } from '../core/rest.service';

import { objectToQueryString } from '../../common/utils';

import { environment } from '../../../environments/environment';

@Injectable()
export class StaffOrderCommentService {
  constructor(private readonly rest: RestService) {}

  getOrderComments(where = null): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/staff/order-comment${objectToQueryString(where)}`);
  }

  getOrderCommentById(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/staff/order-comment/${id}`);
  }

  createOrderComment(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/staff/order-comment`, payload);
  }

  updateOrderComment(id: number, payload): Promise<any> {
    return this.rest.put(`${environment.apiUrl}/api/staff/order-comment/${id}`, payload);
  }

  deleteOrderComment(id: number): Promise<any> {
    return this.rest.delete(`${environment.apiUrl}/api/staff/order-comment/${id}`);
  }
}
